(ns app.survey.form.view
  (:require
   [app.survey.form.event :as events]
   [app.survey.form.sub :as sub]
   [app.survey.sub :as survey-sub]
   [common.languages :as languages]
   [common.localization :as loc]
   [frontend.utils :as fu]
   [frontend.view.nev.surveys.form.components :as components]
   [re-frame.core :as rf]
   [ui.dom-globals :as dg]
   [ui.components.button.view :as button]
   [ui.view.survey.sub :as survey-view-sub]
   [ui.view.survey.view :as survey]))


(defn editor-exit-button
  []
  [button/secondary-open
   {:on-click (fn [e]
                (dg/prevent-and-stop e)
                (rf/dispatch [::events/exit-editor]))}
   (loc/tr :exit)])

(defn editor-exit-without-saving-button
  []
  [button/secondary-hollow
   {:on-click (fn [e]
                (dg/prevent-and-stop e)
                (rf/dispatch [::events/exit-editor]))}
   (loc/tr :exit-without-saving)])

(defn form-v2
  [burned-config accessible-surveys]
  (let [style @(rf/subscribe [::survey-view-sub/form-style (:db/id burned-config)])]
    [:div
     {:class (fu/cs "py-4 flex flex-col flex-auto"
                    (case style
                      :survey-form.style/grid-full "overfow-hidden"
                      "overflow-auto"))}
     [survey/view burned-config (> (count accessible-surveys) 1)]]))

(defn scrollable-form
  []
  (let [config @(rf/subscribe [::sub/config])
        lang @(rf/subscribe [::sub/language])
        lang-options @(rf/subscribe [::sub/lang-options])
        template @(rf/subscribe [::sub/template])
        process @(rf/subscribe [::sub/survey-process])
        tenant @(rf/subscribe [::survey-sub/tenant])
        logo (:survey-template/survey-hero-image template)
        label (or (:label process)
                  (:survey-template/label template))]
    [:div
     {:class "flex flex-col flex-1 overflow-y-auto"}
     [:div
      {:class "max-w-[1024] w-100 mx-auto px-4 pt-2"}
      [components/survey-header
       {:lang           {:value lang
                         :label (languages/get-label lang)}
        :lang-opts      lang-options
        :on-lang-change [::events/lang-change]
        :logo           logo
        :tenant-name    (:tenant/name tenant)
        :survey-label   label}]
      (->> config
           (map-indexed (fn [idx {:keys [block-type] :as block}]
                          (case block-type
                            :survey-block/wysiwyg
                            ^{:key (str "survey-block-" idx)}
                            [components/wysiwyg-section block]
                            :survey-block/section
                            ^{:key (str "survey-block-" idx)}
                            [components/survey-section block]
                            ^{:key (str "survey-block-" idx)}
                            (str (:block-type block)))))
           (doall))]]))

(defn save-buttons
  []
  [:<>
   [button/primary-solid
    {:on-click #(rf/dispatch [::events/save-as-pdf])}
    (loc/tr :survey-submitted-save-as-pdf)]
   [button/primary-solid
    {:on-click #(rf/dispatch [::events/save-as-excel])}
    (loc/tr :survey-submitted-save-as-excel)]])

(defn footer
  []
  (let [status @(rf/subscribe [::sub/process-status])
        unsaved-changes @(rf/subscribe [::sub/unsaved-changes])
        missing-fields @(rf/subscribe [::sub/missing-fields])
        info-file-url (:survey-template/info-file-url @(rf/subscribe [::survey-sub/survey-template]))]
    [:div
     {:class "border-t border-solid border-base-light-border-paler"}
     [:div
      {:class "p-3 mx-auto max-w-[1024px] flex justify-between gap-2"}
      [:div
       {:class "flex gap-3"}
       (if-not unsaved-changes
         [editor-exit-button [::events/exit]]
         [editor-exit-without-saving-button])]
      [:div
       {:class "flex gap-3"}
       [:div
        {:class "p-2 border border-solid border-base-light-border-paler rounded-full"}
        (case status
          :survey-process.status/wip (loc/tr :waiting-for-submission)
          :survey-process.status/prefilled (loc/tr :not-published)
          :survey-process.status/submitted (loc/tr :submitted)
          :survey-process.status/approved (loc/tr :approved)
          :survey-process.status/approved-modified (loc/tr :approved)
          "")]
       (when info-file-url
         [:div
          [:a
           {:href   info-file-url
            :target "_blank"}
           (loc/tr :survey-info-file-link)]])]
      [:div
       {:class "p-4 flex justify-end gap-4"}
       (cond unsaved-changes
             [components/editor-save-button false [::events/save-wip]]
             missing-fields
             [components/missing-fields-button missing-fields]
             (= :survey-process.status/wip status)
             [components/editor-next-button missing-fields [::events/submit-wip]]
             :else
             [save-buttons])]]]))

(defn footer-v2
  [_burned-config]
  (let [survey-id @(rf/subscribe [::sub/survey-id])
        unsaved-answers @(rf/subscribe [::survey-view-sub/unsaved-survey-answers survey-id])
        missing-answers @(rf/subscribe [::survey-view-sub/missing-survey-answers survey-id])
        show-missing? @(rf/subscribe [::survey-view-sub/show-missing? survey-id])
        lang @(rf/subscribe [::survey-view-sub/selected-lang survey-id])
        saving? @(rf/subscribe [::survey-view-sub/saving-survey? survey-id])
        submitted? @(rf/subscribe [::survey-view-sub/survey-submitted? survey-id])]
    [:div
     {:class-name "bg-base-light border-t border-solid border-base-light-border-paler py-2"}
     [:div
      {:class "px-3 mx-auto max-w-[1024px] flex justify-between gap-2"}
      (when-not submitted?
        [:<>
         [button/secondary-open
          {:on-click  #(rf/dispatch [::events/exit-editor])
           :disabled? (or saving? (seq unsaved-answers))}
          (loc/tr :survey-logout-button nil lang)]
         [:div
          {:class-name "flex gap-3"}
          [button/secondary-hollow
           {:on-click  #(rf/dispatch [::events/save survey-id])
            :disabled? (or saving? (empty? unsaved-answers))}
           (if saving?
             [:<>
              [:svg.animate-spin.-ml-1.mr-3.h-5.w-5.text-base-light-text {:xmlns "http://www.w3.org/2000/svg" :fill "none" :viewBox "0 0 24 24"}
               [:circle.opacity-25 {:cx "12" :cy "12" :r "10" :stroke "currentColor" :stroke-width "4"}]
               [:path.opacity-75 {:fill "currentColor" :d "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}]]
              (loc/tr :saving nil lang)]
             (loc/tr :save nil lang))]
          (cond (empty? unsaved-answers)
                [button/primary-solid
                 {:on-click #(rf/dispatch [::events/save-and-submit survey-id])}
                 (loc/tr :submit nil lang)]
                :else
                [button/primary-solid
                 {:on-click  #(rf/dispatch [::events/save-and-submit survey-id])
                  :disabled? (and missing-answers show-missing?)}
                 (loc/tr :save-and-submit nil lang)])]])]]))

(defn survey-form
  []
  (let [burned-config @(rf/subscribe [::sub/burned-config])
        access-to-other-surveys? @(rf/subscribe [::survey-sub/accessible-surveys])]
    (when burned-config
      [:div
       {:class "h-full flex flex-col bg-base-light"}
       [form-v2 burned-config access-to-other-surveys?]
       [footer-v2 burned-config]])))

(defn view
  []
  [survey-form])
